import UtInternalEmbed from "../../../../plugins/ut-social-media-embed/js/component_internal_embed.es6";

const utWebComponents = ()=> {
    window.customElements.define('ut-internal-embed', UtInternalEmbed);
}

export default utWebComponents;
